import { CheckRounded } from "@material-ui/icons";
import Text from "./Text";

export default function ListItem({ config, mode = "LIGHT" }) {
  return (
    <div className="list-item">
      <CheckRounded color="white" />
      <Text
        config={{
          variant: "P",
          color: "light",
          text: config.title,
        }}
      />
    </div>
  );
}
